import { setAuthToken } from ':fat/auth/tokenStore';
import { errorToString } from ':fat/helpers/errors';

import { sanityCheck } from './sanityCheck';

export type HandlerContext = object; // nothing yet

export async function handleMessage(
  _context: HandlerContext,
  message: TaggedMessage<'blockchainWorker'>,
) {
  switch (message.kind) {
    case 'PING': {
      void MessageBus.reply(message, { kind: 'PONG' });
      break;
    }
    case 'SETUP': {
      MessageBus.registerWorkerPort('databaseWorkerPort', message.databaseWorkerPort);
      if (message.authToken) {
        setAuthToken(message.authToken);
      }
      void MessageBus.reply(message, { kind: 'READY' });
      break;
    }
    case 'SANITY_CHECK': {
      const { success, errorMessage } = await sanityCheck();
      void MessageBus.reply(message, {
        kind: 'SANITY_CHECK_RESPONSE',
        success,
        error: errorMessage,
      });
      break;
    }
    case 'SET_DEVTOOL_STATE': {
      self.DEVTOOL_STATE = message.state;
      void MessageBus.reply(message, { kind: 'PONG' });
      break;
    }
    case 'START_SCANNING': {
      void self.BlockchainWorkerLogic.startScanning(message.fingerprint);
      break;
    }
    case 'GET_SCANNING_PROGRESS': {
      const { scanner } = self.BlockchainWorkerLogic;
      if (scanner) {
        const progress = scanner.getProgress();
        void MessageBus.reply(message, { kind: 'SCANNING_PROGRESS', progress });
      } else {
        void MessageBus.reply(message, { kind: 'SCANNING_PROGRESS' });
      }
      break;
    }
    case 'CONSTRUCT_TRANSACTIONS': {
      try {
        const txs = await self.BlockchainWorkerLogic.constructTransactions(
          message.fingerprint,
          message.destinations,
        );
        void MessageBus.reply(message, { kind: 'CONSTRUCTED_TRANSACTIONS', txs });
      } catch (err) {
        void MessageBus.reply(
          message,
          { kind: 'CONSTRUCT_TRANSACTION_ERROR', error: errorToString(err) },
          { rejection: true },
        );
      }

      break;
    }

    // These messages are replies that are handled by the sender of the
    // original message as an awaited Promise. Nothing to do here, other than
    // convince TypeScript that we've handled all message kinds.
    case 'PONG':
    case 'QUERY_RESULT':
    case 'QUERY_ERROR': {
      break;
    }
    default:
      // @ts-expect-error to guarantee we've handled all message kinds. If
      // this is broken, we missed a possible message. Hover over `message.kind`
      // below to see what was missed.
      throw new Error(`Unexpected message: ${message.kind}`);
  }
}
